export default {
  container: {
    gap: '12px',
    alignItems: 'center',
    py: '20px',
    mb: '20px',
  },
  mainLink: {
    height: '20px',
    width: '20px',
    display: 'flex',
    m: 0,
  },
  link: {
    textDecoration: 'none',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 500,
    color: '#667085',
  },
};
